import { useMutation } from "@tanstack/react-query"
import { loginUser, logoutUser } from "../api/auth"
import {
  getUserFromLocalStorage,
  removeTokensFromLocalStorage,
  removeOtpVerificationFromLocalStorage,
  removeUserFromLocalStorage,
} from "../utils"
import { useEffect, useState } from "react"

export const useAuth = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)
  const user = getUserFromLocalStorage()

  useEffect(() => {
    if (user?.userId) {
      setIsUserLoggedIn(true)
    }
  }, [user?.userId])

  const setUserLoggedIn = (value) => setIsUserLoggedIn(value)

  return { user, isUserLoggedIn, setUserLoggedIn }
}

export const useLogin = () =>
  useMutation({
    mutationFn: loginUser,
  })

export const useLogout = () =>
  useMutation({
    mutationFn: logoutUser,
    onSettled: () => {
      removeTokensFromLocalStorage()
      removeUserFromLocalStorage()
      removeOtpVerificationFromLocalStorage()
    },
  })
